"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * sls-lambda
 * REST API definition for Service Location Service.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeEnum = void 0;
/**
 * Error code returned when an operation fails.
 * @export
 * @enum {string}
 */
exports.CodeEnum = {
    ApigwError: 'APIGW_ERROR',
    InvalidRequest: 'INVALID_REQUEST',
    NotFound: 'NOT_FOUND'
};
